import script from "./SelectSearchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSearchComponent.vue?vue&type=script&setup=true&lang=js"

import "./SelectSearchComponent.vue?vue&type=style&index=0&id=ab53c6aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab53c6aa"]])

export default __exports__